import LAYOUT from '@/layouts/default/index.vue';

export default {
  path: '/model',
  component: LAYOUT,
  name: 'Model',
  redirect: '/model/appraise',
  meta: {
    title: '车型',
  },
  children: [
    {
      path: 'appraise',
      name: 'ModelAppraise',
      meta: {
        title: '车型评价',
      },
      component: () => import('@/views/model/appraise/index'),
    },
  ],
};
